import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, LogOut } from "lucide-react";
import { AdminGate } from "@/components/admin/AdminGate";
import { SheetUploader } from "@/components/admin/SheetUploader";
import { EntriesTable } from "@/components/admin/EntriesTable";
import { fetchEntries } from "@/lib/api";

export default function Admin() {
  const [pw, setPw] = useState(null);
  const [entries, setEntries] = useState([]);

  const load = async (password = pw) => setEntries(await fetchEntries(password));
  const onUnlock = async (password) => {
    await load(password);
    setPw(password);
  };

  return (
    <main className="stage-bg min-h-screen px-4 py-10 sm:px-8">
      <div className="mx-auto max-w-5xl">
        <header className="mb-8 flex items-center justify-between">
          <Link to="/" data-testid="admin-back-link" className="flex items-center gap-2 text-sm text-slate-300 hover:text-amber-300">
            <ArrowLeft className="h-4 w-4" /> Back to BollyGPT
          </Link>
          {pw && (
            <button data-testid="admin-logout-button" onClick={() => { setPw(null); setEntries([]); }} className="flex items-center gap-2 text-sm text-slate-300 hover:text-pink-400">
              <LogOut className="h-4 w-4" /> Lock
            </button>
          )}
        </header>
        <h1 className="font-marquee text-4xl text-amber-400 sm:text-5xl">Admin Green Room</h1>
        <p className="mt-2 text-base text-slate-400 md:text-lg">Upload a new spreadsheet to replace the list of questions & songs.</p>
        {!pw ? (
          <AdminGate onUnlock={onUnlock} />
        ) : (
          <div className="mt-10 space-y-10">
            <SheetUploader password={pw} onDone={() => load()} count={entries.length} />
            <EntriesTable entries={entries} />
          </div>
        )}
      </div>
    </main>
  );
}
